module.exports = __webpack_public_path__ + "media/images/landing/home/upload_pictures-c04870a799529b576e0e2a5ab26f8875.png";